 // Iterate over each tabs block
 $('.tabs-block').each(function() {
  var $tabsBlock = $(this);

  // Initialize the first tab as active in this block
  $tabsBlock.find('.tabs-nav li:first-child').addClass('active');
  $tabsBlock.find('.tab-content').hide();
  $tabsBlock.find('.tab-content:first').show();

  // Click function for tabs within this block
  $tabsBlock.find('.tabs-nav li').on('click', function(event) {
    event.preventDefault(); // Prevent the default anchor behavior

    var $this = $(this);

    // Remove active class from all tabs and hide all tab contents within this block
    $tabsBlock.find('.tabs-nav li').removeClass('active');
    $tabsBlock.find('.tab-content').hide();

    // Add active class to the clicked tab and show the corresponding content
    $this.addClass('active');
    var activeTab = $this.find('a').attr('href');

    // Ensure the correct content is shown
    $tabsBlock.find(activeTab).fadeIn();
  });
});